import { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = '确定',
  cancelLabel = '取消',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  // 防止触发弹窗的同一次 click 事件穿透到 overlay 上导致立刻关闭
  useEffect(() => {
    if (!open) return;
    const swallow = (e: MouseEvent) => e.stopPropagation();
    document.addEventListener('click', swallow, true);
    const timer = window.setTimeout(() => {
      document.removeEventListener('click', swallow, true);
    }, 0);
    return () => {
      window.clearTimeout(timer);
      document.removeEventListener('click', swallow, true);
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      className="confirm-dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-dialog-title"
    >
      <div className="confirm-dialog">
        <div id="confirm-dialog-title" className="confirm-dialog-title">
          {title}
        </div>
        <p className="confirm-dialog-message">{message}</p>
        <div className="confirm-dialog-actions">
          <button type="button" className="confirm-dialog-btn confirm-dialog-btn--cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="confirm-dialog-btn confirm-dialog-btn--confirm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
